module.exports = __webpack_public_path__ + "files/d52e356fed1b5025307c738a21099fb3.svg";